module.exports = __webpack_public_path__ + "img/icon_jam_masuk.58d9024f.svg";